export default (theme) => ({
  link: {
    color: theme.palette.primary.color[500],
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
});
